import { html, nothing } from 'lit';
import type { TefComs4cs4p } from '@src/components/TefComs4cs4p';
import { consentStore } from '@src/store';
import { DEFAULT_MSISDN_FILTER } from '@src/store/ConsentStore';

const carouselOptions = {
  type: 'slider',
  rewind: false,
  bound: true,
  perView: 2,
  order: [],
  autoplay: false,
  gap: 10,
  equalHeight: true,
  layout: {
    dots: true, navigation: true, navigationSpaced: true, dotsSpaced: true,
  },
  breakpoints: {
    380: {
      perView: 1,
      order: [3, 2, 1],
      layout: {
        dots: true, dotsSpaced: false, navigation: false, navigationSpaced: false,
      },
    },
  },
};

//
// renders the main TefComs4cs4p
//
export const tefComs4cs4p = function render(this: TefComs4cs4p)
  : ReturnType<typeof html> {
  if (consentStore.initialConsents.length === 0) return html`${nothing}`;

  return html`
    <div class="container" data-testid="root">
      <tef-coms-loader cloak=${!this.cloak || nothing}></tef-coms-loader>

      <section cloak=${this.cloak || nothing}>
        <div class="row align-items-center">
          <div class="col typography-display--4">App-Services</div>
          <tef-shop-switcher-dropdown
            data-testid="dropdown"
            default-value="${DEFAULT_MSISDN_FILTER}"
            dropdown-options=${this.dropdownOptions}
            @occl.shop-switcher-dropdown.changed=${this.handleFilterMsisdn}
            ></tef-shop-switcher-dropdown>
        </div>

        <tef-carousel
          .options=${carouselOptions}
          class="u-sb--flat"
          data-testid="carousel"
          >
          <!-- single purpose -> single subscription -> single app -->
          ${this.consents?.map((purpose) => this.getTemplateFn('singlePurpose')(purpose))}
        </tef-carousel>

        <div class="row col justify-content-center align-items-center">
          <tef-coms-button text="Alle deaktivieren" @click=${this.withdrawAllConsentsForAllPurposes} .disabled=${!consentStore.hasAnyGrantedConsents()} style="margin-right: 10px"></tef-coms-button>
          <tef-coms-button text="Alle zurücksetzen" @click=${this.revertToInitialConsents} .disabled=${!consentStore.hasConsentChange()}></tef-coms-button>
        </div>

        <div class="section section-buttons">
          <div class="form-row form-row--buttons">
            <tef-coms-cancel-button></tef-coms-cancel-button>
            <tef-coms-save-button @click="${this.save}"></tef-coms-save-button>
          </div>
        </div>
      </section>
    </div>
    `;
};
